import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { REGISTER_URL, LINE_URL } from '../../pricing';

const { FiPhone, FiMessageSquare } = FiIcons;

const Registration = () => {
  const contactInfo = [
    {
      icon: FiPhone,
      label: 'โทรศัพท์',
      value: '098-850-5900 (อ.รวิ)',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FiMessageSquare,
      label: 'Line',
      value: '@fengshuix',
      color: 'from-blue-500 to-blue-600'
    }
  ];

  return (
    <section id="registration" className="py-10 md:py-16 bg-gradient-to-br from-red-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">การสมัครและติดต่อ</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ลงทะเบียนและชำระเงินออนไลน์ได้ทันที ด้วยบัตรเครดิตหรือสแกนจ่าย
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <a
            href={REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-10 py-4 bg-gradient-to-r from-green-600 to-green-700 text-white text-xl font-bold rounded-full hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            ลงทะเบียนเข้าร่วมทริป
          </a>
        </motion.div>

        <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            มีคำถาม ติดต่อได้ที่
          </h3>
          <div className="space-y-4">
            {contactInfo.map((contact, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg"
              >
                <div className={`w-12 h-12 bg-gradient-to-br ${contact.color} rounded-lg flex items-center justify-center`}>
                  <SafeIcon icon={contact.icon} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-600">{contact.label}</p>
                  <p className="text-lg font-semibold text-gray-900">{contact.value}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="mt-6 text-center">
            <a
              href={LINE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-700 font-semibold underline"
            >
              ทัก LINE @fengshuix
            </a>
            <p className="text-sm text-gray-600 mt-2">ติดต่อในเวลาทำการ 9:00-18:00 น.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Registration;
